import React from "react";
import img_projet1 from "../img/projet1.png";
import img_projet2 from "../img/projet2.png";
import img_projet3 from "../img/projet3.png";
import ProjectCard from "./Project_card";

export default function MesProjets() {
  return (
    <div id="Projets" className="min-h-screen w-full bg-gradient-to-br from-purple-50 via-purple-100 to-white py-8 sm:py-12 md:py-16">
      <div className="text-center  mb-8 sm:mb-12 md:mb-16">
        <h1 className="text-3xl sm:text-3xl md:text-3xl lg:text-4xl xl:text-5xl font-md px-4 sm:px-6 md:px-8 lg:px-12 xl:px-14">
          Quelques projets ...
        </h1>
      </div>
      <div className="mx-4 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-16 md:gap-6 sm:gap-8 md:gap-10 lg:gap-12 pb-8 sm:pb-10 md:pb-12 px-4 sm:px-6 md:px-8 lg:px-12 xl:px-20">
        <ProjectCard
          title="Site internet de Ramonage + SEO optimisé"
          image={img_projet1}
          description="Site web professionnel pour un ramoneur."
          keyPhrases={[
            "Site sur mesure",
            "SEO optimisé",
            "Acquisition client rapide",
            "Conversion améliorée",
          ]}
        />
        <ProjectCard
          title="Micro-Saas (Softaware as a Service)"
          image={img_projet2}
          description="Micro-Saas de gestion de SMS pour indépendant."
          keyPhrases={[
            "Authentification sécurisée",
            "Gestion API et webhooks",
            "Gestion abonnements Stripe",
            "Supabase + Next.js",
          ]}
        />
        <ProjectCard
          title="Module Dolibarr (ERP) personnalisé"
          image={img_projet3}
          description="Module sur mesure d'un ERP  pour une gestion efficace de la flotte."
          keyPhrases={[
            "Gestion de flotte",
            "Suivi historique",
            "Alertes intelligentes",
            "Optimisation des opérations",
          ]}
        />
      </div>
    </div>
  );
}
